import { Loader2 } from "lucide-react";

export default function DeleteQuoteConfirmModal({ open, quote, saving, error, onConfirm, onCancel }) {
  if (!open || !quote) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/40 p-4" data-testid="quote-delete-confirm-modal">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl dark:bg-[#111C33]">
        <h3 className="text-base font-bold text-slate-950 dark:text-white">Delete this quote?</h3>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
          {quote.quote_id} for {quote.company} will be permanently deleted. This cannot be undone.
        </p>
        {error && <p className="mt-3 rounded-xl bg-red-50 px-3 py-2 text-sm font-semibold text-red-700 dark:bg-red-500/10 dark:text-red-400" data-testid="quote-delete-error">{error}</p>}
        <div className="mt-5 flex items-center gap-3">
          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            data-testid="quote-delete-confirm-btn"
            className="inline-flex items-center gap-2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {saving && <Loader2 size={14} className="animate-spin" />}
            Yes, delete quote
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            data-testid="quote-delete-cancel-btn"
            className="rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 disabled:opacity-50 dark:border-white/15 dark:text-slate-200 dark:hover:bg-white/10"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
